import { Typography } from '@mui/material'
import { styled } from '@mui/system'

export const PhotoWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'withAddIconStyles',
})<{ withAddIconStyles?: boolean }>(({ theme, withAddIconStyles }) => ({
  width: 150,
  height: 208,
  backgroundColor: '#D5d5d5',
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  paddingBottom: theme.spacing(6),
  borderRadius: theme.spacing(0.5),
  overflow: 'hidden',
  flexShrink: 0,
  '& + div': {
    marginLeft: theme.spacing(1),
  },
  ...(withAddIconStyles && {
    justifyContent: 'center',
    paddingBottom: 0,
    backgroundColor: '#f1f1f1',
    width: '140px',
    height: '198px',
    overflow: 'visible',
  }),
}))

export const PhotoTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'component',
})<{ component?: React.ElementType }>(({ theme }) => ({
  textAlign: 'left',
  width: '100%',
  margin: theme.spacing(2, 0),
}))
